export const genreOptions = [
  "剧情",
  "悬疑",
  "科幻",
  "冒险",
  "爱情",
  "动作",
  "战争",
  "犯罪",
  "惊悚",
  "青春",
  "运动",
  "历史",
  "奇幻",
  "古装",
  "都市",
  "情感",
  "医疗",
  "职场",
  "家庭",
  "治愈",
  "年代",
  "传记",
  "文艺",
];

export const regionOptions = ["中国大陆", "中国香港", "中国台湾", "美国", "英国", "韩国", "日本"];

export const yearOptions = [2024, 2023, 2022, 2021];

export const typeMeta: Record<
  string,
  { label: string; title: string; description: string }
> = {
  movie: {
    label: "电影",
    title: "秋霞影院 - 电影分类列表",
    description:
      "秋霞影院电影专区汇集剧情、悬疑、科幻、动作等各类高清电影资源，支持按类型、地区、年份筛选查找，方便影迷快速发现想看的影片。",
  },
  tv: {
    label: "电视剧",
    title: "秋霞影院 - 电视剧分类列表",
    description:
      "秋霞影院电视剧专区收录古装、都市、刑侦、年代等热门剧集，支持多条件筛选与排序，帮助你便捷找到高分好评的电视剧作品。",
  },
};

export const categoryEntries = [
  {
    key: "movie",
    label: "电影专区",
    icon: "ri-film-line",
    description: "剧情、悬疑、科幻、动作，海量高清电影随心筛选",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20scene%20of%20a%20dark%20movie%20theater%20with%20glowing%20deep%20blue%20seats%20and%20warm%20orange%20screen%20light%2C%20editorial%20atmospheric%20style&width=600&height=400&seq=qx-cat-movie&orientation=landscape",
  },
  {
    key: "tv",
    label: "电视剧专区",
    icon: "ri-tv-2-line",
    description: "古装、都市、刑侦、年代，追更热门剧集不容错过",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20scene%20of%20a%20cozy%20living%20room%20with%20a%20glowing%20television%20casting%20deep%20blue%20and%20warm%20orange%20light%2C%20editorial%20atmospheric%20style&width=600&height=400&seq=qx-cat-tv&orientation=landscape",
  },
];